import HTTP from '../http'
import Schedule from './scheduleModel'

import AppointmentService from '../appointments/appointmentService'
import LocationService from '../locations/locationService'

const compileAppointments = async (schedule: Schedule, location_id: string, date: string, withClientInfo: boolean) => {
  let slotAppointmentInfo: any = []

  const appointments = await (withClientInfo ? AppointmentService.searchWithClient(location_id, date) : AppointmentService.search(location_id, date))
  schedule.appointments = appointments

  if (schedule.is_open) {
    if (schedule.location.schedule_type === 'schedule.thirty' || schedule.location.schedule_type === 'schedule.kartThirty') {
      schedule.hours_of_operation.forEach((hoo: any) => {
        let availableSpots = schedule.spots.filter((spot: any) => spot.hours.includes(hoo))
        let currentAppointmentsInSlot = appointments.filter((a: any) => a.time === hoo).sort((a,b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          /* ts-ignore */
          return new Date(b.appointmentDate).getTime() - new Date(a.appointmentDate).getTime()
        })

        let count = availableSpots.length - currentAppointmentsInSlot.length
        let timeSplit = hoo.split(':')
        slotAppointmentInfo.push({
          time: hoo,
          localTime: `${timeSplit[0] > 12 ? timeSplit[0] - 12 : timeSplit[0]}:${timeSplit[1]} ${timeSplit[0] >= 12 ? 'PM' : 'AM'}`,
          available: count,
          appointments: currentAppointmentsInSlot
        })
      })

      schedule.slotAppointmentInfo = slotAppointmentInfo
    } else if (schedule.location.schedule_type === 'schedule.queue') {
      schedule.slotAppointmentInfo = [{
        time: date,
        localTime: date,
        available: 1,
        appointments: appointments
      }]
    }
  }

  schedule.remainingAppts = appointments.filter((appt: any) => appt.appointmentType !== 1 && appt.appointmentType !== 3)

  return schedule
}

const scheduleService = {
  async get (location_id: string, filter_date: string, withClientInfo: boolean) {
    const loc = await LocationService.getById(location_id)

    let schedule = await HTTP.post('', {
      query: `
        query ($location_id: String!, $filter_date: String!) {
          schedule (location_id: $location_id, filter_date: $filter_date) {
            hours_of_operation,
            day,
            day_of_week,
            day_of_week_abbr,
            is_open,
            location {
              _key,
              id,
              name,
              schedule_type,
              position {
                lat,
                lng
              }
            },
            spots {
              available,
              hours,
              name
            }
          }
        }
      `,
      variables: {
        location_id: loc._key,
        filter_date: filter_date
      }
    }).then((res: any) => {
      const data = res.data.data.schedule
      const schedule = new Schedule(data)
      return schedule
    })

    schedule = await compileAppointments(schedule, loc.id, filter_date, withClientInfo)
    return Promise.resolve(schedule)
  }
}

export default scheduleService
